import api from "../../utils/apiPublic";

export const getProductosPublic = async (params = {}) => {
  const {
    limit = 20,
    offset = 0,
    search = "",
    category = null,
    brand = null,
    subcategory = null,
    oferta = false,
    destacados = false,
  } = params;

  const res = await api.get("/api/public/productos", {
    params: {
      limit,
      offset,
      search: String(search ?? "").trim(),
      category: category ?? "",
      brand: brand ?? "",
      subcategory: subcategory ?? "",
      oferta: oferta ? 1 : "",
      destacados: destacados ? 1 : "",
    },
  });

  return res.data;
};

export const getProductoPublicById = async (id) => {
  const res = await api.get(`/api/public/productos/${id}`);
  return res.data;
};

export const getProductosRelacionados = async (id) => {
  const res = await api.get(`/api/public/productos/${id}/relacionados`);
  return res.data;
};
